module.exports = __webpack_public_path__ + "static/media/fornitori_gare_appalto.36a58b51.md";